
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const HomeRoute = () => {
  const { user, loading } = useAuth();
  
  console.log('HomeRoute (App Domain) - user:', user?.id, 'loading:', loading);
  
  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-uplivion-lightBlue bg-opacity-20">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-uplivion-blue mx-auto mb-4"></div>
          <p className="text-uplivion-blue">Lädt...</p>
        </div>
      </div>
    );
  }
  
  if (user) {
    console.log('HomeRoute (App Domain) - User authenticated, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }
  
  console.log('HomeRoute (App Domain) - No user, redirecting to login');
  return <Navigate to="/login" replace />;
};

export default HomeRoute;
